import React, { useState } from "react";
import {
  ESTIMATE_SOURCES,
  ESTIMATES_DISCLAIMER,
  PUBLIC_API_PROVIDERS,
} from "../../data/estimateSources";

export interface EstimatesDisclaimerProps {
  /** Show the expandable breakdown of each estimate type. */
  showBreakdown?: boolean;
  className?: string;
}

const EstimatesDisclaimer: React.FC<EstimatesDisclaimerProps> = ({
  showBreakdown = true,
  className = "",
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <aside
      className={`border border-solid border-[rgba(0,0,0,0.08)] bg-bg-porcelain p-4 md:p-5 ${className}`}
      aria-label="Estimates disclaimer"
    >
      <p className="text-xs text-text-grey leading-relaxed">
        <span className="font-medium text-text-slate">Estimates only — </span>
        {ESTIMATES_DISCLAIMER}
      </p>

      <p className="text-xs text-text-grey mt-2 leading-relaxed">
        <span className="font-medium text-text-slate">Data providers: </span>
        {PUBLIC_API_PROVIDERS.join("; ")}. All other figures use listing data,
        internal lookup tables, or simplified heuristics — not live pricing APIs.
      </p>

      {showBreakdown && (
        <>
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            className="mt-3 font-manrope text-xs uppercase tracking-wider text-brand-gold hover:text-brand-yellow transition-colors"
            aria-expanded={expanded}
          >
            {expanded ? "Hide estimate details" : "How each estimate is calculated"}
          </button>

          {expanded && (
            <ul className="mt-3 space-y-2 text-xs text-text-grey">
              {ESTIMATE_SOURCES.map((item) => (
                <li
                  key={item.label}
                  className="border-t border-t-solid border-t-[rgba(0,0,0,0.06)] pt-2 first:border-t-0 first:pt-0"
                >
                  <span className="font-medium text-text-slate">{item.label}</span>
                  {item.provider ? (
                    <span className="text-text-grey"> · {item.provider}</span>
                  ) : null}
                  <div className="mt-0.5">{item.accuracy}</div>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </aside>
  );
};

export default EstimatesDisclaimer;
